<template>
  <div class="space-y-4">
    <h2>{{ t('vatRates') }}</h2>
    <MultipleValuesListField
      name="vatRates"
      :button-text="t('addVatRate')"
      :field-settings="fieldSettings"
      show-delete-alert
    />
  </div>
</template>

<script lang="ts" setup>
import MultipleValuesListField, {
  type FieldSettings,
} from '@/components/MultipleValuesListField.vue';
import { getCountries } from '@/utils/countries';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n();

const fieldSettings = computed<FieldSettings[]>(() => [
  {
    name: 'country',
    label: t('country'),
    placeholder: t('chooseCountry'),
    type: 'searchable-select',
    options: getCountries(locale.value),
    trackBy: ['label', 'labelEn', 'labelShort', 'value', 'alternativeNames'],
  },
  {
    name: 'validFrom',
    label: t('validFrom'),
    type: 'date',
    calendarDate: true,
  },
  {
    name: 'taxPercent',
    label: t('vatRate'),
    type: 'number',
    min: 0,
    max: 100,
    maxFractionDigits: 2,
    adornment: '%',
  },
]);
</script>

<i18n lang="json">
{
  "en": {
    "vatRates": "VAT rates per country",
    "country": "Country",
    "validFrom": "Valid from",
    "vatRate": "VAT rate",
    "chooseCountry": "Choose country",
    "addVatRate": "+ Add VAT rate"
  },
  "de": {
    "vatRates": "Mehrwertsteuersätze pro Land",
    "country": "Land",
    "validFrom": "Ab-Datum",
    "vatRate": "Steuersatz",
    "chooseCountry": "Land auswählen",
    "addVatRate": "+ Neuen Steuersatz hinzufügen"
  },
  "es": {
    "vatRates": "Tipos de IVA por país",
    "country": "País",
    "validFrom": "Válido desde",
    "vatRate": "Tipo de IVA",
    "chooseCountry": "Elegir país",
    "addVatRate": "+ Añadir tipo de IVA"
  }
}
</i18n>
